export default "__VITE_ASSET__f7b9c563__"